import { useFormik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/header/Header.tsx";
import Navbar from "../../components/navbar/Navbar.tsx";
import Footer from "../../components/footer/Footer.tsx";
import styles from "./Support.module.css";
import support from "../../assets/images/support.svg";
import { postFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { useEffect, useState } from "react";
import Spinner from "../spinner/Spinner.tsx";
import { useUser } from "../../context/UserContext.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";

const Support = () => {
  const { t } = useLanguage();
  const [loading, setLoading] = useState(false);
  const { user } = useUser();

  // LOADİNG
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required(t('support', 'i1E')),
      lastName: Yup.string().required(t('support', 'i2E')),
      email: Yup.string().required(t('support', 'i3E')),
      subject: Yup.string().required(t('support', 'i4E')),
      message: Yup.string().required(t('support', 'i5E')),
    }),
    onSubmit: async (values) => {
      try {
        const response = await postFetcher(endpoints.support.CreateSupports, {
          arg: {
            userId: user ? user.id : null,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            subject: values.subject,
            description: values.message,
          },
        });

        if (response.result) {
          toast.success(t("toastMessage", "rate19"));
          formik.resetForm();
        } else {
          toast.error(t("toastMessage", "rate20"));
        }
      } catch (error) {
        toast.error(t("toastMessage", "rate20"));
        console.error("Error submitting support request:", error);
      }
    },
  });

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <Navbar />
      {loading && (
        <div>
          <Spinner />
        </div>
      )}
      <main className="flex-grow bg-primary-color mb-32 my-4">
        {/* TOP */}
        <div
          className={`w-full bg-white  ${styles.topSide} p-4 md:p-32 flex flex-col lg:flex-row items-center justify-center`}
        >
          {/* LEFT */}
          <div className="w-full lg:w-1/2 p-4 text-center lg:text-left lg:mb-0">
            <h2 className="text-3xl md:text-5xl text-black">
              {/* İletişime Geçin! */}
              {t("support", "title")}
            </h2>
            <p className="text-black mt-4 text-base md:text-lg leading-relaxed mx-auto lg:mx-0 max-w-lg">
              {/* "İhtiyacınız Olduğunda, Yanınızdayız! deneyimli ekibimiz, size en
              iyi hizmeti sunmak için hazır. şimdi bize ulaşın ve sorularınızı
              sormaktan çekinmeyin!" */}
              {t("support", "description")}
            </p>
            <p className="text-primary-color mt-4 text-lg md:text-xl font-semibold leading-relaxed mx-auto lg:mx-0 max-w-lg">
              {/* Her zaman yanınızdayız! */}
              {t("support", "subTitle")}
            </p>
          </div>

          {/* RIGHT */}
          <div className="w-full lg:w-1/2 p-4 flex justify-center">
            <form
              onSubmit={formik.handleSubmit}
              className="bg-white px-4 md:px-8 pt-6 pb-8 mb-12 w-full max-w-lg"
            >
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-md font-bold mb-2"
                  htmlFor="firstName"
                >
                  {t('support', 'i1')}
                </label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    formik.touched.firstName && formik.errors.firstName
                      ? "border-red-500"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                />
                {formik.touched.firstName && formik.errors.firstName ? (
                  <p className="text-red-500 text-xs italic">
                    {formik.errors.firstName}
                  </p>
                ) : null}
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-md font-bold mb-2"
                  htmlFor="lastName"
                >
                  {t('support', 'i2')}
                </label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    formik.touched.lastName && formik.errors.lastName
                      ? "border-red-500"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName ? (
                  <p className="text-red-500 text-xs italic">
                    {formik.errors.lastName}
                  </p>
                ) : null}
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-md font-bold mb-2"
                  htmlFor="email"
                >
                  {t('support', 'i3')}
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    formik.touched.email && formik.errors.email
                      ? "border-red-500"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email ? (
                  <p className="text-red-500 text-xs italic">
                    {formik.errors.email}
                  </p>
                ) : null}
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-md font-bold mb-2"
                  htmlFor="subject"
                >
                  {t('support', 'i4')}
                </label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    formik.touched.subject && formik.errors.subject
                      ? "border-red-500"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.subject}
                />
                {formik.touched.subject && formik.errors.subject ? (
                  <p className="text-red-500 text-xs italic">
                    {formik.errors.subject}
                  </p>
                ) : null}
              </div>
              <div className="mb-6">
                <label
                  className="block text-gray-700 text-md font-bold mb-2"
                  htmlFor="message"
                >
                  {t('support', 'i5')}
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={6}
                  className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    formik.touched.message && formik.errors.message
                      ? "border-red-500"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.message}
                />
                {formik.touched.message && formik.errors.message ? (
                  <p className="text-red-500 text-xs italic">
                    {formik.errors.message}
                  </p>
                ) : null}
              </div>
              <div className="flex items-center justify-end">
                <button
                  type="submit"
                  className="bg-primary-color hover:bg-red-800 text-white font-bold py-2  px-4 w-full md:w-36 tracking-wide rounded focus:outline-none focus:shadow-outline"
                >
                  {t('support', 'button')}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* BOTTOM */}
        <div
          className={`w-full flex justify-center  lg:justify-start items-center p-4 md:p-8 ${styles.bottomSide}`}
        >
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="p-4 md:p-8 rounded-full bg-primary-color relative -top-16 md:-top-32 lg:-top-52">
              <img
                src={support}
                alt="Support"
                className="w-48 h-48 md:w-72 md:h-72 lg:w-96 lg:h-96"
              />
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ top: "120px" }}
      />
    </div>
  );
};

export default Support;
